import { Box, Fade, Grid, Modal, Typography } from '@mui/material';
import * as React from 'react';
import { FailedSVG, SuccessFilled, WarningSVG } from '../../assets/img';
import { AsyncButton } from '../ButtonNew/Button';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 420,
  maxHeight: 350,
  bgcolor: 'background.paper',
  borderRadius: '8px',
  textAlign: 'center',
  boxShadow: 24,
};

export const ModalAlert = ({ children, open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Fade in={open}>
        <Box sx={style}>{children}</Box>
      </Fade>
    </Modal>
  )
}

type ErrorLevel = 'error' | 'info' | 'warning' | 'success';
const AlertIcon: Record<ErrorLevel, React.ReactElement | null> = {
  error: <FailedSVG style={{ height: 48, width: 48 }} />,
  info: null,
  warning: <WarningSVG />,
  success: <SuccessFilled />,
};

const Icon = ({ severity }) => {
  return (
    <Grid display={'flex'} alignItems={'center'} justifyContent={'center'} marginBottom={'2rem'}>
      {AlertIcon[severity] || null}
    </Grid>
  )
}
Icon.displayName = 'ModalAlert.Icon';
ModalAlert.Icon = Icon;

const Content = ({ messageTitle, messageDesc }) => {
  return (
    <Typography
      id="modal-modal-description"
      sx={{ mt: 2 }}
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <h5 className="font-weight-bold mb-3">{messageTitle}</h5>
      {messageDesc && (
        <p className="mb-0" style={{ textAlign: 'center', maxWidth: '364px' }}>
          {messageDesc}
        </p>
      )}
    </Typography>
  )
}
Content.displayName = 'ModalAlert.Content';
ModalAlert.Content = Content;

const Actions = ({ primaryAction, onClose }: {
  primaryAction?: any;
  onClose?: () => void;
}) => {
  return (
    <Grid display={'flex'} gap={2} alignItems={'center'} justifyContent={'center'} sx={{ padding: '16px' }}>
      <AsyncButton
        type="button"
        color="primary"
        variant="outlined"
        style={{ minWidth: '100px' }}
        onClick={async () => {
          onClose();
        }}
      >
        {'Tutup'}
      </AsyncButton>
      {primaryAction && (
        <AsyncButton
          {...primaryAction}
          style={{ minWidth: '100px' }}
          onClick={async () => {
            if (primaryAction?.onClick) {
              await primaryAction?.onClick();
            }
            onClose();
          }}
        >
          {primaryAction?.label}
        </AsyncButton>
      )}
    </Grid>
  )
}
Actions.displayName = 'ModalAlert.Actions';
ModalAlert.Actions = Actions;